export default __webpack_public_path__ + "static/media/sdump-busd.11eb2c8d.png";